import { render, staticRenderFns } from "./Program_technologies.vue?vue&type=template&id=12b80b1a&scoped=true&"
import script from "./Program_technologies.vue?vue&type=script&lang=js&"
export * from "./Program_technologies.vue?vue&type=script&lang=js&"
import style0 from "./Program_technologies.vue?vue&type=style&index=0&id=12b80b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b80b1a",
  null
  
)

export default component.exports